<div class="list-page kapea" style="max-width: 1400px; padding: 0 3vw 5vh 4vw">
  <!-- <app-asiakas-koti-otsikko></app-asiakas-koti-otsikko> -->

  <div style="margin-top: 5px; display: flex; justify-content: space-between; width: 999px">
    <form novalidate class="ylaosan-kontrollit" style="margin-left: 17px">
      <!--<mat-form-field *ngIf="naytaSuperObservable | async" style="width: 200px; margin-right: 20px;">
      <mat-label>Rajaa tiimikokonaisuuden mukaan</mat-label>
      <mat-select formControlName="tiimiKokonaisuus">
        <mat-option [value]="null">
          Kaikki
        </mat-option>
        <mat-option *ngFor="let tiimi of tiimikokonaisuudetObservable | async" [value]="tiimi.avain">
          {{ tiimi.nimi }}
        </mat-option>
      </mat-select>
    </mat-form-field>-->
      <table class="no-border">
        <tr>
          <td></td>
          <td>
            @if (naytaSuperObservable | async) {
              <mat-checkbox [checked]="naytaPoistuneetKirjanpitajatSubject | async" (change)="toggleNaytaPoistuneetKirjanpitajat()" style="margin-right: 20px; transform: scale(0.6); transform-origin: left center"> Näytä poistuneet </mat-checkbox>
            }
          </td>
          <td></td>
        </tr>

        <tr>
          <td>
            @if (naytaSuperObservable | async) {
              <mat-form-field style="width: 155px; margin-right: 20px">
                <mat-label>Rajaa tiimin mukaan</mat-label>
                <mat-select [formField]="lomake.tiimi">
                  <mat-option [value]="null"> Kaikki </mat-option>
                  @for (tiimi of tiimitObservable | async; track tiimi) {
                    <mat-option [value]="tiimi.avain">
                      {{ tiimi.nimi }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </td>
          <td>
            @if (naytaSuperObservable | async) {
              <mat-form-field style="width: 200px; margin-right: 20px">
                <mat-label>Rajaa kirjanpitäjän mukaan</mat-label>
                <mat-select [formField]="lomake.kirjanpitaja">
                  <mat-option [value]="null"> Kaikki </mat-option>
                  @for (kirjanpitaja of kirjanpitajienNimitiedotObservable | async; track kirjanpitaja) {
                    <mat-option [value]="kirjanpitaja.avain"> {{ kirjanpitaja.etunimi }} {{ kirjanpitaja.sukunimi }} </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </td>
          <td>
            @if (naytaSuperObservable | async) {
              <mat-form-field style="width: 155px; margin-right: 20px">
                <mat-label>Rajaa tagin mukaan</mat-label>
                <mat-select [formField]="lomake.tagi">
                  <mat-option [value]="null"> Kaikki </mat-option>
                  @for (tagi of kaikkiTagitObservable | async; track tagi.avain) {
                    <mat-option [value]="tagi.avain">
                      {{ tagi.nimi }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </td>
          <td>
            <mat-form-field style="width: 90px; margin-right: 20px">
              <mat-label>Kuukaudesta</mat-label>
              <input matInput [matDatepicker]="dp1" [formField]="lomake.vuosikkalku" />
              <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
              <mat-datepicker #dp1 startView="year" (monthSelected)="chosenMonthHandlerAlku($event, dp1)" panelClass="kuukausi-valitsin"></mat-datepicker>
            </mat-form-field>
            <mat-form-field style="width: 90px">
              <mat-label>Kuukauteen</mat-label>
              <input matInput [matDatepicker]="dp2" [formField]="lomake.vuosikkloppu" />
              <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
              <mat-datepicker #dp2 startView="year" (monthSelected)="chosenMonthHandlerLoppu($event, dp2)" panelClass="kuukausi-valitsin"></mat-datepicker>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </form>
  </div>

  @if (periodinLoppuInfoObservable | async; as periodinLoppuInfo) {
    <div style="display: flex; gap: 16px; margin-left: 130px; margin-top: 20px">
      <div class="stats-ribbon yellow-ribbon">
        <div class="stat-content">
          @if (jatkuvanLaskutuksenKehitysTableLataa()) {
            <mat-spinner diameter="30"></mat-spinner>
          }
          @if (!jatkuvanLaskutuksenKehitysTableLataa()) {
            <div class="stat-title">Liikevaihto</div>
            <div class="stat-number">{{ periodinLoppuInfo.liikevaihto | number: '1.2-2' }} €</div>
            <div class="stat-date">{{ periodinLoppuInfo.kuukausi }}/{{ periodinLoppuInfo.vuosi }}</div>
          }
        </div>
      </div>
      <div class="stats-ribbon blue-ribbon">
        <div class="stat-content">
          @if (jatkuvanLaskutuksenKehitysTableLataa()) {
            <mat-spinner diameter="30"></mat-spinner>
          }
          @if (!jatkuvanLaskutuksenKehitysTableLataa()) {
            <div class="stat-title">
              Asiakkaita
              <span class="info-icon-wrapper">
                <mat-icon class="info-icon">info_outline</mat-icon>
                <span class="custom-tooltip"> Asiakkaiden määrä kuukauden lopussa (hinta ja sopimus voimassa, ei tauolla tai pöytälaatikossa).<br />T = koko kuukauden tauolla olevat<br />P = koko kuukauden pöytälaatikossa olevat </span>
              </span>
            </div>
            <div class="stat-number">{{ periodinLoppuInfo.asiakkaita }}</div>
            <span class="stat-date">{{ periodinLoppuInfo.kuukausi }}/{{ periodinLoppuInfo.vuosi }}</span>
            <div class="stat-additional">
              <div>T: {{ periodinLoppuInfo.tauolla }}</div>
              <div>P: {{ periodinLoppuInfo.poytalaatikossa }}</div>
            </div>
          }
        </div>
      </div>
      <div class="stats-ribbon yellow-ribbon">
        <div class="stat-content">
          @if (jatkuvanLaskutuksenKehitysTableLataa()) {
            <mat-spinner diameter="30"></mat-spinner>
          }
          @if (!jatkuvanLaskutuksenKehitysTableLataa()) {
            <div class="stat-title">Keskim. veloitus</div>
            <div class="stat-number">{{ periodinLoppuInfo.keskihinta | ldecimal: 2 | async }} €</div>
            <span class="stat-date">{{ periodinLoppuInfo.kuukausi }}/{{ periodinLoppuInfo.vuosi }}</span>
          }
        </div>
      </div>
      <div class="stats-ribbon green-ribbon">
        <div class="stat-content">
          @if (jatkuvanLaskutuksenKehitysTableLataa()) {
            <mat-spinner diameter="30"></mat-spinner>
          }
          @if (!jatkuvanLaskutuksenKehitysTableLataa()) {
            <div class="stat-title">Yhtiömuodot</div>
            <div class="chart-wrapper">
              <canvas #yhtiojakaumaCanvas class="yhtiomuodot-canvas" width="62" height="62"></canvas>
            </div>
            <span class="stat-date no-margin">{{ periodinLoppuInfo.kuukausi }}/{{ periodinLoppuInfo.vuosi }}</span>
          }
        </div>
      </div>
    </div>
  }

  <div style="display: grid; grid-template-columns: 1fr; width: 999px; max-width: 1200px; padding-right: 3vw">
    <mat-card class="taulukko-card mat-elevation-z12" style="margin-top: 30px">
      <div>
        <mat-card-header>
          <mat-card-title>Myyntiyhteenveto</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="taulukko-wrapper">
            <table class="mtable myynti" [class.hidden]="myyntiyhteenvetoTableLataa()">
              @for (rivi of myyntiYhteenvetoObservable | async; track rivi) {
                @if (!rivi.kuuluuKategoriaan || avautunutMyyntiyhteenvetoKategoriat.has(rivi.kuuluuKategoriaan)) {
                  <tr [class.bold-row]="rivi.bold" [class.kategoria-rivi]="rivi.kategoriaAvain" [class.alakategoria-rivi]="rivi.onAlakategoria" [class.yhteensa-rivi]="rivi.onYhteensaRivi">
                    @for (td of rivi.cols; track td; let isFirst = $first; let isLast = $last) {
                      <td
                        [class.selected-cell]="valittuMyyntiyhteenvetoSolu() === td"
                        [class.clickable]="!isFirst && !isLast && (!rivi.kategoriaAvain || rivi.onKlikattavaKategoria || rivi.onYhteensaRivi)"
                        [class.kategoria-clickable]="rivi.kategoriaAvain && isFirst"
                        (click)="isFirst && rivi.kategoriaAvain ? toggleMyyntiyhteenvetoKategoria(rivi.kategoriaAvain) : !isLast && (!rivi.kategoriaAvain || rivi.onKlikattavaKategoria || rivi.onYhteensaRivi) ? avaaSolunTiedotMyyntiyhteenveto(td, rivi.nimi, isFirst) : null"
                      >
                        @if (rivi.kategoriaAvain && isFirst && (!rivi.onKlikattavaKategoria || rivi.onYhteensaRivi)) {
                          <span class="kategoria-vakanen">
                            <mat-icon>{{ avautunutMyyntiyhteenvetoKategoriat.has(rivi.kategoriaAvain) ? 'expand_less' : 'expand_more' }}</mat-icon>
                          </span>
                        }
                        @if (rivi.kategoriaAvain && isFirst && rivi.onKlikattavaKategoria && !rivi.onYhteensaRivi) {
                          <span class="kategoria-vakanen"> &nbsp; </span>
                        }
                        {{ td.arvo }}
                      </td>
                    }
                  </tr>
                  @if (valittuMyyntiyhteenvetoSolu() && rivi.nimi === valittuMyyntiyhteenvetoTuoteNimi() && (!rivi.kategoriaAvain || rivi.onKlikattavaKategoria)) {
                    <tr class="solu-lahteet-row">
                      <td colspan="100%">
                        <div class="solu-lahteet">
                          <h4>{{ valittuMyyntiyhteenvetoTuoteNimi() }} — {{ valittuMyyntiyhteenvetoSolu().kuukausi }}/{{ valittuMyyntiyhteenvetoSolu().vuosi }}</h4>
                          @if (lataaMyyntiyhteenvetoLahteet()) {
                            <div style="display: flex; justify-content: center">
                              <mat-spinner diameter="30"></mat-spinner>
                            </div>
                          }
                          @if (myyntiyhteenvetoLahteetEiTasmaa()) {
                            <div style="background-color: #fff3cd; border: 1px solid #ffc107; padding: 10px; margin-bottom: 10px; border-radius: 4px">
                              <strong>Summat eivät täsmää, päivitä sivu uudelleen</strong>
                            </div>
                          }
                          @if (!lataaMyyntiyhteenvetoLahteet() && valitunMyyntiyhteenvetoSolunLahteet() && valitunMyyntiyhteenvetoSolunLahteet().length) {
                            <table>
                              @for (lahde of valitunMyyntiyhteenvetoSolunLahteet(); track lahde) {
                                <tr>
                                  <td>
                                    <a [href]="'/asiakkaat/' + lahde.av + '/laskutus/katsele/' + (lahde.j || lahde.a) + '/' + lahde.a" target="_blank">
                                      {{ lahde.n }}
                                    </a>
                                  </td>
                                  <td>
                                    <a [href]="'/asiakkaat/' + lahde.av + '/asiakastiedot'" target="_blank">
                                      {{ lahde.asiakasNimi }}
                                    </a>
                                  </td>
                                  <td style="text-align: right; padding-left: 50px; padding-right: 50px">{{ lahde.s | ldecimal: 2 | async }} €</td>
                                </tr>
                              }
                              <tr>
                                <td colspan="2" style="text-align: right; padding-right: 20px">Yhteensä:</td>
                                <td style="text-align: right; padding-left: 50px; padding-right: 50px">{{ myyntiyhteenvetoLahteidenSumma() | ldecimal: 2 | async }} €</td>
                              </tr>
                            </table>
                          }
                          @if (!lataaMyyntiyhteenvetoLahteet() && valitunMyyntiyhteenvetoSolunLahteet() && !valitunMyyntiyhteenvetoSolunLahteet().length) {
                            <div class="tyhja">Ei lähdetietoja</div>
                          }
                        </div>
                      </td>
                    </tr>
                  }
                }
              }
            </table>
          </div>
          @if (myyntiyhteenvetoTableLataa()) {
            <div style="display: flex; justify-content: center">
              <mat-spinner></mat-spinner>
            </div>
          }
        </mat-card-content>
        <div style="margin-top: 20px; margin-left: 20px">
          <p class="gray-text" style="font-size: 13px">
            Taulukko näyttää kaikkien lähetettyjen laskujen yhteenlasketun myynnin kuukausittain. Hyvityslaskut näytetään tuotteissa omilla riveillään. Mikäli laskua muokataan tai sen omistajaa muutetaan takautuvasti, muutos päivittyy myös myyntiyhteenvetoon. <a href="https://app.tettra.co/teams/lemontree/pages/myyntiyhteenveto-luvut" target="_blank" class="taulukko-linkki">Lue lisää</a>
          </p>
        </div>
      </div>
    </mat-card>

    <mat-card class="taulukko-card mat-elevation-z12" style="margin-top: 50px">
      <div>
        <mat-card-header class="taulukko-otsikko">
          <mat-card-title>Jatkuvan laskutuksen kehitys</mat-card-title>
          @if (naytaSuperObservable | async) {
            <app-secondary-button (click)="lataaJatkuvanLaskutuksenKehitysCsv()" actionId="Lataa jatkuvan laskutuksen kehitys CSV" matIcon="download" [disabled]="jatkuvanLaskutuksenKehitysTableLataa()">Lataa CSV</app-secondary-button>
          }
        </mat-card-header>
        <mat-card-content>
          <div class="taulukko-wrapper">
            <table class="mtable" [class.hidden]="jatkuvanLaskutuksenKehitysTableLataa()">
              @for (rivi of jatkuvanLaskutuksenKehitysObservable | async; track rivi) {
                <tr [class.bold-row]="rivi.bold" [class.grey]="rivi.grey" [class.divider]="rivi.divider" [class.offset]="rivi.offset">
                  <td>{{ rivi.nimi }}</td>
                  @for (td of rivi.cols; track td) {
                    <td class="clickable" (click)="avaaSolunTiedot(td)" [class.selected-cell]="valittuSolu() === td">
                      {{ td.arvo }}
                    </td>
                  }
                </tr>
                @if (valittuSolu() && rivi.cols[0]?.kentta === valittuSolu().kentta) {
                  <tr class="solu-lahteet-row">
                    <td colspan="100%">
                      <div class="solu-lahteet">
                        <h4>{{ rivi.nimi }} — {{ valittuSolu().kuukausi }}/{{ valittuSolu().vuosi }}</h4>
                        @if (lataaLahteet()) {
                          <div style="display: flex; justify-content: center">
                            <mat-spinner diameter="30"></mat-spinner>
                          </div>
                        }
                        @if (jatkuvaLaskutusValidointi().eiTasmaa) {
                          <div style="background-color: #fff3cd; border: 1px solid #ffc107; padding: 10px; margin-bottom: 10px; border-radius: 4px">
                            <strong>Summat tai kappalemäärät eivät täsmää, päivitä sivu uudelleen</strong>
                          </div>
                        }
                        @if (!lataaLahteet() && valitunSolunLahteet() && valitunSolunLahteet().length) {
                          <table>
                            @for (lahde of valitunSolunLahteet(); track lahde) {
                              <tr>
                                <td>
                                  <a [href]="'/asiakkaat/' + lahde.asiakasAvain + '/laskutus'" target="_blank">
                                    {{ lahde.nimi }}
                                  </a>
                                </td>
                                <td style="text-align: right; padding-right: 50px">{{ lahde.summa | ldecimal: 2 | async }} €</td>
                              </tr>
                            }
                            <tr style="border-top: 1px solid #ddd; font-weight: bold">
                              <td>Yhteensä ({{ valitunSolunLahteet().length }} kpl)</td>
                              <td style="text-align: right; padding-right: 50px">{{ valitunSolunLahteetYhteissumma() | ldecimal: 2 | async }} €</td>
                            </tr>
                          </table>
                        }
                        @if (!lataaLahteet() && valitunSolunLahteet() && !valitunSolunLahteet().length) {
                          <div class="tyhja">Ei lähdetietoja</div>
                        }
                      </div>
                    </td>
                  </tr>
                }
              }
            </table>
          </div>
          @if (jatkuvanLaskutuksenKehitysTableLataa()) {
            <div style="display: flex; justify-content: center">
              <mat-spinner></mat-spinner>
            </div>
          }
        </mat-card-content>
        <div style="margin-top: 20px; margin-left: 20px">
          <p class="gray-text" style="font-size: 13px">
            Taulukko kuvaa asiakkaiden jatkuvan laskutuksen kehitystä kuukausittain. Tiedot perustuvat asiakkaiden kuukausittaisen palvelumaksun muutoksiin, ja niissä huomioidaan myös tulevaisuuteen ajoittuvat hinnanmuutokset. <a href="https://app.tettra.co/teams/lemontree/pages/jatkuvan-laskutuksen-kehitys-luvut" target="_blank" class="taulukko-linkki">Lue lisää</a>
          </p>
        </div>
      </div>
    </mat-card>
  </div>

  <!--
  <div style="display: flex; flex-flow: row wrap; margin-top: 50px">
    <div style="max-width: 800px; flex-grow: 1">
      <div style="margin: 20px 0">
        <div style="font-size: 24px; margin-right: 10px; margin-bottom: 5px">Kuukausilaskutus</div>
      </div>

      <canvas [class.hidden]="kuukausittainCanvasDataOnLataamatta()" #kuukausittainCanvas></canvas>
      <table [class.hidden]="kuukausittainCanvasDataOnLataamatta()" class="ftable">
        @for (rivi of kuukausittaisenDatanRivitObservable | async; track rivi) {
          <tr [class.bold-row]="rivi.bold" [class.mini-row]="!rivi.bold">
            @for (td of rivi.cols; track $index) {
              <td>{{ td }}</td>
            }
          </tr>
        }
      </table>
      @if (kuukausittainCanvasDataOnLataamatta()) {
        <div style="display: flex; justify-content: center">
          <mat-spinner></mat-spinner>
        </div>
      }
    </div>
  </div>
  -->

  <!--
  <div style="display: flex; flex-flow: row wrap">
    <div style="max-width: 800px; flex-grow: 1">
      <div style="display: flex; flex-flow: row wrap; align-items: center; margin: 60px 0 20px 0">
        <div style="font-size: 24px; margin-right: 10px">Jatkuvan laskutuksen hinnaston muutos kuukausittain</div>
      </div>

      <canvas [class.hidden]="kuukausittainenMuutosCanvasOnLataamatta" #kuukausittainenMuutosCanvas></canvas>
      @if (kuukausittainenMuutosCanvasOnLataamatta) {
        <div style="display: flex; justify-content: center">
          <mat-spinner></mat-spinner>
        </div>
      }
    </div>
  </div>
  -->

  @if (naytaSuperObservable | async) {
    <div style="margin: 2em 0; border: 1px dashed lightgray; padding: 1em">
      <span>Nämä tiedot näkyvät vain pääkäyttäjälle</span>
      <!--<div style="max-width: 1000px">
        <div style="display: flex; flex-flow: row wrap; align-items: center; margin: 60px 0 20px 0">
          <div style="font-size: 24px; margin-right: 10px">Kuukausilaskutus kirjanpitäjittäin</div>
        </div>
        <canvas [class.hidden]="kuukausittainKirjanpitajittainCanvasOnLataamatta()" #kuukausittainKirjanpitajittainCanvas></canvas>
        @if (kuukausittainKirjanpitajittainCanvasOnLataamatta()) {
          <div style="display: flex; justify-content: center">
            <mat-spinner></mat-spinner>
          </div>
        }
      </div>-->
      <div style="display: flex; flex-flow: row wrap; align-items: center; margin: 60px 0 20px 0">
        <div style="font-size: 24px; margin-right: 10px">Hinnan muutokset asiakkaittain</div>
        <span class="info-icon-wrapper">
          <mat-icon class="info-icon">info_outline</mat-icon>
          <span class="custom-tooltip"> Tagirajaus: asiakas näytetään, jos valittu tagi on ollut voimassa vähintään yhtenä kuukausirajauksen kuukautena. </span>
        </span>
      </div>
      <table class="asiakkaat-table" style="border-spacing: 0">
        <thead>
          <tr>
            <th>Asiakas</th>
            <th>Vastuukirjanpitäjä</th>
            @for (kuukausi of purettuAikavaliPlusKuukausiMolempiinPaihinObservable | async; track kuukausi) {
              <th>{{ kuukausi.year }}/{{ kuukausi.month }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (asiakkaanHinnanMuutokset of asiakkaidenKuukausihintojenMuutoksetObservable | async; track asiakkaanHinnanMuutokset) {
            <tr>
              <td style="white-space: nowrap">{{ asiakkaanHinnanMuutokset.asiakas?.n }}</td>
              <td style="white-space: nowrap">{{ asiakkaanHinnanMuutokset.kirjanpitaja?.etunimi }} {{ asiakkaanHinnanMuutokset.kirjanpitaja?.sukunimi }}</td>
              @for (kkhinta of asiakkaanHinnanMuutokset.hinnat; track kkhinta) {
                <td style="text-align: right; padding-left: 10px; white-space: nowrap">
                  <div [class.green-text]="kkhinta.muutos > 0" [class.red-text]="0 > kkhinta.muutos" [title]="kkhinta.syy">&nbsp;{{ kkhinta.muutos | lmoney: 'EUR' | async }}</div>
                  <div style="font-size: 8px; line-height: 6px" class="light-gray-text">{{ kkhinta.hinta | lmoney: 'EUR' | async }}</div>
                </td>
              }
            </tr>
          }
        </tbody>
        <tfoot>
          <tr style="font-weight: bold">
            <td colspan="2" style="white-space: nowrap">Poistuma</td>
            @for (kksumma of asiakkaidenKuukausihintojenSummatObservable | async; track kksumma) {
              <td style="text-align: right; padding-left: 10px; white-space: nowrap" [class.green-text]="kksumma.poistuma > 0" [class.red-text]="0 > kksumma.poistuma">{{ kksumma.poistuma | lmoney: 'EUR' | async }}</td>
            }
          </tr>
          <tr style="font-weight: bold">
            <td colspan="2" style="white-space: nowrap">Lisäys</td>
            @for (kksumma of asiakkaidenKuukausihintojenSummatObservable | async; track kksumma) {
              <td style="text-align: right; padding-left: 10px; white-space: nowrap" [class.green-text]="kksumma.lisays > 0" [class.red-text]="0 > kksumma.lisays">{{ kksumma.lisays | lmoney: 'EUR' | async }}</td>
            }
          </tr>
          <tr style="font-weight: bold">
            <td colspan="2" style="white-space: nowrap">Muutos</td>
            @for (kksumma of asiakkaidenKuukausihintojenSummatObservable | async; track kksumma) {
              <td style="text-align: right; padding-left: 10px; white-space: nowrap" [class.green-text]="kksumma.summa > 0" [class.red-text]="0 > kksumma.summa">{{ kksumma.summa | lmoney: 'EUR' | async }}</td>
            }
          </tr>
        </tfoot>
      </table>
      <!-- <div style="display: flex; flex-flow: row wrap; align-items: center; margin: 60px 0 20px 0;">
    <div style="font-size: 24px; margin-right: 10px;">Duplikaattilaskut viimeisen 3kk ajalta</div>
  </div>
  <div *ngIf="duplikaatitLataavatObservable | async" style="display: flex; justify-content: center;">
    <mat-spinner></mat-spinner>
  </div>
  <table *ngIf="!(duplikaatitLataavatObservable | async)" class="asiakkaat-table" style="border-spacing: 0;">
    <thead>
      <tr>
        <th style="padding-right: 5px;">Asiakas</th>
        <th style="padding-right: 5px;">Pvm</th>
        <th>Laskunro 1</th>
        <th style="padding-left: 5px;">Laskunro 2</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let duplikaatti of duplikaattiLaskutObservable | async">
        <td style="white-space: nowrap; padding-right: 5px;">{{duplikaatti.asiakas?.nimi}}</td>
        <td style="white-space: nowrap; padding-right: 5px;">{{duplikaatti.pvm | lokaalipvm | async}}</td>
        <td style="white-space: nowrap; text-align: right;">{{ duplikaatti.laskunro1 }}</td>
        <td style="white-space: nowrap; text-align: right; padding-left: 5px;">{{ duplikaatti.laskunro2 }}</td>
      </tr>
    </tbody>
  </table> -->
      <div>
        <div style="display: flex; flex-flow: row wrap; align-items: center; margin: 60px 0 20px 0">
          <div style="font-size: 24px; margin-right: 10px">Kirjanpitäjät</div>
        </div>
        <form novalidate style="margin: auto 0 auto auto">
          <mat-form-field style="width: 90px; margin-right: 20px">
            <mat-label>Kuukausi</mat-label>
            <input matInput [matDatepicker]="dp3" [formField]="kirjanpitajatLomake.vuosikkalku" />
            <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
            <mat-datepicker #dp3 startView="year" (monthSelected)="chosenMonthHandlerKirjanpitajatAlku($event, dp3)" panelClass="kuukausi-valitsin"></mat-datepicker>
          </mat-form-field>
        </form>
        @if (kirjanpitajittainTableLataa()) {
          <div style="display: flex; justify-content: center">
            <mat-spinner></mat-spinner>
          </div>
        }
        <!-- class="mat-elevation-z8" -->
        <mat-table [class.hidden]="kirjanpitajittainTableLataa()" [dataSource]="kirjanpitajatDataSource" matSort matSortActive="kirjanpitaja" matSortDisableClear matSortDirection="asc">
          <ng-container matColumnDef="kirjanpitaja">
            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Kirjanpitäjä</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.kirjanpitaja }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>Yhteensä</mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="asiakkaita">
            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Asiakkaita</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.asiakkaita }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{ kirjanpitajittainTableYhteensa().asiakkaita }}</mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="keskimveloitus">
            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Keskim. laskutus</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.keskimaarainenVeloitus | lmoney: 'EUR' | async }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{ kirjanpitajittainTableYhteensa().keskim | lmoney: 'EUR' | async }}</mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="jatkuvakk1">
            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Jatkuva laskutus {{ valittuKirjanpitajienKk1Observable | async }}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.jatkuvakk1 | lmoney: 'EUR' | async }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{ kirjanpitajittainTableYhteensa().jatkuvakk1 | lmoney: 'EUR' | async }}</mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="jatkuvakk2">
            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Jatkuva laskutus {{ valittuKirjanpitajienKk2Observable | async }}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.jatkuvakk2 | lmoney: 'EUR' | async }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{ kirjanpitajittainTableYhteensa().jatkuvakk2 | lmoney: 'EUR' | async }}</mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="lisaykset">
            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Lisäykset</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.lisaykset | lmoney: 'EUR' | async }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{ kirjanpitajittainTableYhteensa().lisayksia | lmoney: 'EUR' | async }}</mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="vahennykset">
            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Vähennykset</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.vahennykset | lmoney: 'EUR' | async }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{ kirjanpitajittainTableYhteensa().poistuma | lmoney: 'EUR' | async }}</mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="yhtiomuodot">
            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Yhtiömuodot {{ valittuKirjanpitajienKk1Observable | async }}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.yhtiomuotoString }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{ kirjanpitajittainTableYhteensa().tmi }}/{{ kirjanpitajittainTableYhteensa().oy }}/{{ kirjanpitajittainTableYhteensa().muut }}</mat-footer-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="['kirjanpitaja', 'jatkuvakk1', 'lisaykset', 'vahennykset', 'jatkuvakk2', 'asiakkaita', 'keskimveloitus', 'yhtiomuodot']"></mat-header-row>
          <mat-row *matRowDef="let row; columns: ['kirjanpitaja', 'jatkuvakk1', 'lisaykset', 'vahennykset', 'jatkuvakk2', 'asiakkaita', 'keskimveloitus', 'yhtiomuodot']"></mat-row>
          <mat-footer-row *matFooterRowDef="['kirjanpitaja', 'jatkuvakk1', 'lisaykset', 'vahennykset', 'jatkuvakk2', 'asiakkaita', 'keskimveloitus', 'yhtiomuodot']"></mat-footer-row>
        </mat-table>
      </div>
    </div>
    @if (naytaSpeccerObservable | async) {
      <h3 style="margin-top: 8em">Tästä alaspäin debug-dataa</h3>
      <!-- <h3 style="margin-top: 2em">
        Toteutuneen kuukausiveloituksen data
        <mat-checkbox style="font-size: 10px" class="light-gray-text" [formField]="naytaTarkkaJakauma" [labelPosition]="'after'">Näytä tarkka jakauma</mat-checkbox>
      </h3>
      <table style="text-align: right">
        <tr>
          <th style="text-align: center">Vuosi / kk</th>
          <th style="text-align: center">Jatkuvalaskutus</th>
          <th style="text-align: center">Jatkuvat hyvitykset</th>
          <th style="text-align: center">Kertalaskutus</th>
          <th style="text-align: center">Kerta hyvitykset</th>
          <th style="text-align: center">Tuntematon laskutus</th>
          <th style="text-align: center">Yhteensä</th>
        </tr>
        @for (kk of kuukausittainenJakaumaObservable | async; track kk) {
          <tr>
            <td style="text-align: left">{{ kk.vuosi }} / {{ kk.kuukausi }}</td>
            <td>{{ kk.jatkuvalaskutus | lmoney: 'EUR' | async }}</td>
            <td>{{ kk.jatkuvahyvitykset | lmoney: 'EUR' | async }}</td>
            <td>{{ kk.kertalaskutus | lmoney: 'EUR' | async }}</td>
            <td>{{ kk.kertahyvitykset | lmoney: 'EUR' | async }}</td>
            <td>{{ kk.tuntematon | lmoney: 'EUR' | async }}</td>
            <td>{{ kk.yhteensa | lmoney: 'EUR' | async }}</td>
          </tr>
          @if (naytaTarkkaJakauma().value()) {
            @for (lahde of kk.lahteet; track lahde) {
              <tr style="font-size: 8px; line-height: 8px" class="light-gray-text">
                <td colspan="2" style="text-align: left"></td>
                <td>{{ lahde.juurilaskuAvain }}</td>
                <td>{{ lahde.laskunro }} ({{ lahde.lahetystyyppi === 'j' ? 'Jatkuva' : 'Kerta' }})</td>
                <td>{{ lahde.summa | lmoney: 'EUR' | async }}</td>
              </tr>
            }
          }
        }
      </table> -->
      <h3 style="margin-top: 2em">Keskimääräiset hinnat</h3>
      Asiakkaita: {{ (asiakasInfoObservable | async)?.asiakkaita }} <br />
      Asiakkaita, joilla on hinta nyt: {{ (asiakasInfoObservable | async)?.asiakkaitaJoillaHinta }} <br />
      Keskimääräinen hinta: {{ (asiakasInfoObservable | async)?.keskimaarainenhinta | lmoney: 'EUR' | async }} <br />
      Yhtiömuotojakauma:
      <table>
        <tr>
          <th>Nimi</th>
          <th>Määrä</th>
          <th>Keskimääräinen hinta</th>
        </tr>
        @for (yhtiomuoto of (asiakasInfoObservable | async)?.yhtiomuotojakauma; track yhtiomuoto) {
          <tr>
            <td>{{ yhtiomuoto.nimi }}</td>
            <td style="text-align: right">{{ yhtiomuoto.maara }}</td>
            <td style="text-align: right">{{ yhtiomuoto.keskimaarainenHinta | lmoney: 'EUR' | async }}</td>
          </tr>
        }
      </table>
    }
    <!-- <h3 style="margin-top: 2em">
      Laskutus kirjanpitäjittäin
      <mat-checkbox style="font-size: 10px" class="light-gray-text" [formField]="naytaTarkkaJakaumaKirjanpitajat" [labelPosition]="'after'">Näytä tarkka jakauma</mat-checkbox>
    </h3> -->
    <!-- <app-secondary-button (click)="lataaLaskutusKirjanpitajittain2020Viiva2024()" actionId="Lataa laskutus kirjanpitajittain 2020 - 2024 koneelle"> Lataa laskutus kirjanpitajittain 2020 - 2024 </app-secondary-button>
    <table style="text-align: right">
      <tr>
        <th style="text-align: center">Kirjanpitaja</th>
        <th style="text-align: center">Vuosi / kk</th>
        <th style="text-align: center">Jatkuvalaskutus</th>
        <th style="text-align: center">Kertalaskutus</th>
        <th style="text-align: center">Tuntematon laskutus</th>
        <th style="text-align: center">Yhteensä</th>
      </tr>
      @for (kk of kirjanpitajittainJakaumaObservable | async; track kk) {
        <tr>
          <td style="text-align: left">{{ kk.kirjanpitaja }}</td>
          <td style="text-align: left">{{ kk.vuosi }} / {{ kk.kuukausi }}</td>
          <td>{{ kk.jatkuvalaskutus | lmoney: 'EUR' | async }}</td>
          <td>{{ kk.kertalaskutus | lmoney: 'EUR' | async }}</td>
          <td>{{ kk.tuntematon | lmoney: 'EUR' | async }}</td>
          <td>{{ kk.yhteensa | lmoney: 'EUR' | async }}</td>
        </tr>
        @if (naytaTarkkaJakaumaKirjanpitajat().value()) {
          @for (lahde of kk.lahteet; track lahde) {
            <tr style="font-size: 8px; line-height: 8px" class="light-gray-text">
              <td colspan="5">{{ lahde.laskunro }} ({{ lahde.lahetystyyppi === 'j' ? 'Jatkuva' : 'Kerta' }})</td>
              <td>{{ lahde.summa | lmoney: 'EUR' | async }}</td>
            </tr>
          }
        }
      }
    </table> -->
  }
</div>
